import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';

// Links shared before the overview existed pointed at the health cards with their filters at the root.
const HEALTH_PARAMS = ['status', 'q', 'sort', 'view', 'group'];

const legacyHealthLink: CanActivateFn = (route) => {
  const router = inject(Router);
  const params = route.queryParams;
  return HEALTH_PARAMS.some((name) => name in params)
    ? router.createUrlTree(['/application-insights'], { queryParams: params })
    : true;
};

// The shell shows the page that matches the address; the routes only say which addresses exist.
export const routes: Routes = [
  { path: '', pathMatch: 'full', canActivate: [legacyHealthLink], children: [] },
  { path: 'application-insights', children: [] },
  { path: 'service-bus', children: [] },
  // The sign-in address and anything unknown land on the health tab.
  { path: '**', redirectTo: '' },
];
